import axios from 'axios';
import API_BASE_URL from '../config.js';
import RegisterServices from './RegisterServices.js';

const AuthServices = async (ciam_id, userData) => {
    try {
        // Realiza una solicitud GET con el parámetro ciam_id en la URL
        const response = await axios.get(`${API_BASE_URL}api/login/`, {
            params: {
                ciam_id: ciam_id
            },
            headers: {
                'Content-Type': 'application/json', // Tipo de contenido de la solicitud
            }
        });

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 400) {
            // Llama a RegisterServices y luego vuelve a intentar AuthServices
            await RegisterServices(userData);
            return await AuthServices(ciam_id, userData); // Reintenta la autenticación después del registro
        } else {
            console.error("error", error.message); // Mostrar cualquier otro error
            throw error; // Propaga el error para que pueda ser manejado por el llamador
        }
    }
};

export default AuthServices;
